// extracted by mini-css-extract-plugin
export default {"GlobalSearch":"index__GlobalSearch__IKvGb","GlobalSearchOverlay":"index__GlobalSearchOverlay__GI2gX"};